var _path, _path2, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFrameworks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.347656 2.21722C0.347656 1.18469 1.18469 0.347656 2.21722 0.347656H7.82592C8.85845 0.347656 9.69548 1.18469 9.69548 2.21722V7.82592C9.69548 8.85845 8.85845 9.69548 7.82592 9.69548H2.21722C1.18469 9.69548 0.347656 8.85845 0.347656 7.82592V2.21722Z",
    fill: "#044D9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.347656 15.3041C0.347656 14.2716 1.18469 13.4346 2.21722 13.4346H7.82592C8.85845 13.4346 9.69548 14.2716 9.69548 15.3041V20.9128C9.69548 21.9454 8.85845 22.7824 7.82592 22.7824H2.21722C1.18469 22.7824 0.347656 21.9454 0.347656 20.9128V15.3041Z",
    fill: "#044D9F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5645,
    y: 1.28223,
    width: 13.087,
    height: 2.80435,
    rx: 0.934783,
    fill: "#5487C1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5645,
    y: 5.95605,
    width: 13.087,
    height: 2.80435,
    rx: 0.934783,
    fill: "#044D9F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5645,
    y: 14.3691,
    width: 13.087,
    height: 2.80435,
    rx: 0.934783,
    fill: "#5487C1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5645,
    y: 19.0439,
    width: 13.087,
    height: 2.80435,
    rx: 0.934783,
    fill: "#044D9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameworks);
export default __webpack_public_path__ + "static/media/frameworks.3949bf5a7ee9b015159ffa572deea1ab.svg";
export { ForwardRef as ReactComponent };